import { Injectable, OnInit } from '@angular/core';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SessionExpirationService } from './session-expiration.service';

@Injectable({
  providedIn: 'root',
})
export class OidcAuthenticationService implements OnInit {
  defaultUrl: string = window.location.origin;
  isSessionExpired: boolean;

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private sessionExpirationService: SessionExpirationService
  ) {}

  ngOnInit(): void {
    this.sessionExpirationService.isSessionExpired.subscribe(
      (isSessionExpired) => (this.isSessionExpired = isSessionExpired)
    );
  }

  /**
   * Init authentication
   */
  async initAuth(): Promise<any> {
    return new Promise<void>((resolveFn, rejectFn) => {
            this.oauthService.configure({
        // Url of the Identity Provider
        issuer: environment.issuer,
        redirectUri: this.defaultUrl,
        clientId: environment.clientId,
        responseType: 'code',
        scope: environment.scope,
        showDebugInformation: !environment.production,
      });
      this.oauthService.tokenValidationHandler = new JwksValidationHandler();
      this.oauthService.events.subscribe((event) => {
        if (event.type === 'invalid_nonce_in_state' || event instanceof OAuthErrorEvent) {
          console.log("Redirect to defaultUrl");
          window.location.href = this.defaultUrl;
        }
        if (event.type === 'token_expires') {
          if (!this.isSessionExpired) {
            this.isSessionExpired = true;
            this.sessionExpirationService.setIsSessionExpired(true);
            console.log("openDialog session expired");
            this.sessionExpirationService.openDialog(() => {
              this.oauthService.logOut();
            });
          }
        }
      });
      this.oauthService.loadDiscoveryDocumentAndLogin().then((isLoggedIn) => {
        if (isLoggedIn) {
          this.oauthService.setupAutomaticSilentRefresh();
          resolveFn();
        } else {
          this.oauthService.initImplicitFlow(
            encodeURIComponent(this.router.url)
          );
          rejectFn();
        }
      });
    });
  }
}
